import {Route, Routes, useLocation} from "react-router-dom";
import "../../assets/css/common.css";
import React, {lazy, Suspense, useEffect} from "react";

const Home = lazy(() => import('../home').then((module) => ({default: module.Home})));

const PostCard = lazy(() => import('../postcard').then((module) => ({default: module.PostCard})));
const PostCardQr = lazy(() => import('../postcard/qr').then((module) => ({default: module.PostCardQr})));
const PostCardCreate = lazy(() => import('../postcard/create').then((module) => ({default: module.PostCardCreate})));
const PostCardResult = lazy(() => import('../postcard/result').then((module) => ({default: module.PostCardResult})));

const Lucky = lazy(() => import('../lucky').then((module) => ({default: module.Lucky})));
const LuckyPrivacy = lazy(() => import('../lucky/privacy').then((module) => ({default: module.LuckyPrivacy})));
const LuckyDraw = lazy(() => import('../lucky/draw').then((module) => ({default: module.LuckyDraw})));
const LuckyResult = lazy(() => import('../lucky/result').then((module) => ({default: module.LuckyResult})));

export const App = () => {
    const location = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [location.pathname]);

    return (
        <Suspense>
            <Routes>
                <Route path="/" element={<Home/>}/>

                <Route path="/postcard" element={<PostCard/>}/>
                <Route path="/postcard/qr" element={<PostCardQr/>}/>
                <Route path="/postcard/create" element={<PostCardCreate/>}/>
                <Route path="/postcard/result" element={<PostCardResult/>}/>

                <Route path="/lucky" element={<Lucky/>}/>
                <Route path="/lucky/privacy" element={<LuckyPrivacy/>}/>
                <Route path="/lucky/draw" element={<LuckyDraw/>}/>
                <Route path="/lucky/result" element={<LuckyResult/>}/>
            </Routes>
        </Suspense>
    );
}
